import { render, staticRenderFns } from "./GreckieWakacje.html?vue&type=template&id=5f17018b&scoped=true&external"
import script from "./GreckieWakacje.js?vue&type=script&lang=js&external"
export * from "./GreckieWakacje.js?vue&type=script&lang=js&external"
import style0 from "./GreckieWakacje.css?vue&type=style&index=0&id=5f17018b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f17018b",
  null
  
)

export default component.exports